import * as React from 'react';
import { SVGProps } from 'react';

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.7188 2.625H7.21875C7.0447 2.625 6.87778 2.69414 6.75471 2.81721C6.63164 2.94028 6.5625 3.1072 6.5625 3.28125V6.5625H3.28125C3.1072 6.5625 2.94028 6.63164 2.81721 6.75471C2.69414 6.87778 2.625 7.0447 2.625 7.21875V17.7188C2.625 17.8928 2.69414 18.0597 2.81721 18.1828C2.94028 18.3059 3.1072 18.375 3.28125 18.375H13.7812C13.9553 18.375 14.1222 18.3059 14.2453 18.1828C14.3684 18.0597 14.4375 17.8928 14.4375 17.7188V14.4375H17.7188C17.8928 14.4375 18.0597 14.3684 18.1828 14.2453C18.3059 14.1222 18.375 13.9553 18.375 13.7812V3.28125C18.375 3.1072 18.3059 2.94028 18.1828 2.81721C18.0597 2.69414 17.8928 2.625 17.7188 2.625ZM13.125 17.0625H3.9375V7.875H13.125V17.0625ZM17.0625 13.125H14.4375V7.21875C14.4375 7.0447 14.3684 6.87778 14.2453 6.75471C14.1222 6.63164 13.9553 6.5625 13.7812 6.5625H7.875V3.9375H17.0625V13.125Z"
      fill="#071114"
    />
  </svg>
);
export default CopyIcon;
